module.exports = __webpack_public_path__ + "static/media/bigpic-sub-01.9c7b3b46.jpg";